// Typelizer digest e15d12e487154e41b84b6ea4e6743d3c
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/documents/:document_id/extractions */
  create: (
    params: { documentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/documents/:document_id/extractions', params, options),
    method: 'post',
  }),
}
